{
  "page": {
    "title": "Notifications",
    "subtitle": "{{count}} notifications",
    "unread_count": "{{count}} unread",
    "all_caught_up": "You're all caught up"
  },
  "filter": {
    "all": "All",
    "unread": "Unread",
    "alerts": "Alerts",
    "severity_label": "Severity",
    "severity_all": "All severities",
    "type_label": "Type",
    "type_all": "All types",
    "read_label": "Read status",
    "read_all": "All",
    "read_unread": "Unread only",
    "read_read": "Read only"
  },
  "action": {
    "mark_read": "Mark read",
    "mark_all_read": "Mark all read",
    "view_in_report": "View in report",
    "view_all": "View all",
    "load_more": "Load more"
  },
  "severity": {
    "P1": "Critical",
    "P2": "Warning",
    "P3": "Info"
  },
  "state": {
    "empty": "No notifications",
    "error": "Failed to load notifications. Try refreshing the page.",
    "loading": "Loading notifications…",
    "unread": "Unread"
  },
  "channel": {
    "telegram": "Telegram",
    "email": "Email"
  },
  "tabs": {
    "label": "Notification tabs",
    "inbox": "Inbox",
    "settings": "Settings"
  },
  "settings": {
    "tab": "Settings",
    "th_event": "Event",
    "th_severity": "Severity",
    "th_threshold": "Threshold",
    "th_actions": "Actions",
    "recipients": "Recipients",
    "mute_window": "Mute window",
    "telegram_recipient": "Telegram recipient",
    "tg_detect_btn": "Detect group",
    "tg_detect_detecting": "Detecting…",
    "tg_detect_saved": "Found group: {{title}} — saved",
    "tg_detect_empty": "No group found. Add the bot to your group and send /start@bot, then try again.",
    "tg_detect_unavailable": "Telegram bot isn't configured. Ask an admin to set NOTIF_TELEGRAM_BOT_TOKEN.",
    "tg_detect_conflict": "A webhook is active, so group detection is unavailable. Remove the webhook and try again.",
    "tg_detect_error": "Couldn't detect the group. Please try again.",
    "tg_pick_title": "Multiple groups found — pick one:",
    "email_recipient": "Email recipient",
    "mute_from": "From",
    "mute_to": "To",
    "preview": "Preview",
    "test_send": "Test send",
    "save": "Save changes",
    "saved": "Settings saved.",
    "test_sent": "Test notification rendered.",
    "preview_title": "Channel preview",
    "close": "Close",
    "event_sync": "Stock sync failed",
    "event_oversold": "Oversold detected",
    "event_quota": "GWP quota exhausted",
    "event_quota_low": "GWP quota low",
    "event_diff": "Inventory DIFF over threshold",
    "event_order_oos": "Order can't be fulfilled",
    "event_sync_stale": "Sync is stale",
    "event_sync_paused": "Stock push paused",
    "event_buyer_cancel_requested": "Buyer requested cancellation",
    "event_listing_discovery": "New listing discovered",
    "event_listing_multi_warehouse": "Listing spans multiple warehouses",
    "test_result_sent": "Sent",
    "test_result_failed": "Failed",
    "test_result_skipped": "Skipped",
    "telegram_recipient_placeholder": "-1001234567890",
    "email_recipient_placeholder": "ops@company.com",
    "tg_guide_title": "How to set up Telegram",
    "tg_guide_steps": [
      "Create a bot: message @BotFather, send /newbot, copy the token.",
      "An admin sets the token on the server (NOTIF_TELEGRAM_BOT_TOKEN) — one time.",
      "Add the bot to your group, then send /start@bot in the group.",
      "Click \"Detect group\" next to the Telegram recipient above — it fills in the chat id and saves automatically.",
      "Click Test send to verify it reaches the group."
    ]
  },
  "delivery": {
    "tab": "Delivery Log",
    "kpi_sent": "Total Sent",
    "kpi_failed": "Failed",
    "kpi_retrying": "Retrying",
    "th_event": "Event",
    "th_channel": "Channel",
    "th_recipient": "Recipient",
    "th_time": "Time",
    "th_status": "Status",
    "th_action": "Action",
    "filter_all": "All",
    "filter_sent": "Sent",
    "filter_failed": "Failed",
    "filter_retrying": "Retrying",
    "status_sent": "Sent",
    "status_failed": "Failed",
    "status_retrying": "Retrying",
    "retry": "Retry",
    "retry_for": "Retry {{title}}",
    "export": "Export CSV",
    "retry_ok": "Retry queued.",
    "exported": "Delivery log exported.",
    "empty": "No delivery records.",
    "error": "Failed to load delivery log."
  },
  "type": {
    "sync_stale": "Sync is stale",
    "sync_paused": "Stock push paused",
    "buyer_cancel_requested": "Buyer requested cancellation",
    "listing_discovery": "New listing discovered",
    "listing_multi_warehouse": "Listing spans multiple warehouses"
  }
}
